import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChatReplyComponent } from './chat-reply/chat-reply.component'
import { ChatThreadComponent } from './chat-thread/chat-thread.component'
import { CommonsModule } from '@commons/commons.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ChatFileComponent } from './chat-file/chat-file.component'
import { PipeModule } from '@app/pipes/pipe.module'
import { ChatReactionComponent } from './chat-reaction/chat-reaction.component'
import { CommunicationReactionComponent } from './communication-reaction/communication-reaction.component'
import { ChatContentComponent } from './chat-content/chat-content.component'

const DECLARATIONS = [
    ChatReplyComponent,
    ChatThreadComponent,
    CommunicationReactionComponent,
    ChatReactionComponent,
    ChatFileComponent,
    ChatContentComponent,
]

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        CommonsModule,
        PipeModule,
    ],
    exports: [...DECLARATIONS],
    declarations: [...DECLARATIONS],
})
export class ChatModule {
}



// WEBPACK FOOTER //
// ./src/app/commons/chat/chat.module.ts